module.exports = __webpack_public_path__ + "static/P4-f24dcbfa542c140a1d57801d9301e01e.jpg";